import { render } from "./AssignUsers.vue?vue&type=template&id=1408a680&scoped=true"
import script from "./AssignUsers.vue?vue&type=script&lang=js"
export * from "./AssignUsers.vue?vue&type=script&lang=js"

import "./AssignUsers.vue?vue&type=style&index=0&id=1408a680&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1408a680"]])

export default __exports__